export default __webpack_public_path__ + "static/media/ic-pl.4f1344be.svg";